import React, { useEffect } from "react";
import "./newlyweds-hero.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
import NewlywedsImg from "../../../../Assets/Hall/kamin43.jpg";

export default function NewlywedsHero() {
  /*----- Intersection Observer -----*/
  useEffect(() => {
    const faders = document.querySelectorAll(".fade-in");
    const sliders = document.querySelectorAll(".slide-in");

    const appearOptions = {
      threshold: 0,
      rootMargin: "0px 0px -200px 0px",
    };

    const appearOnScroll = new IntersectionObserver(function (
      entries,
      appearOnScroll
    ) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        } else {
          entry.target.classList.add("appear");
          appearOnScroll.unobserve(entry.target);
        }
      });
    },
    appearOptions);

    faders.forEach((fader) => {
      appearOnScroll.observe(fader);
    });

    sliders.forEach((slider) => {
      appearOnScroll.observe(slider);
    });
  }, []);

  const { t } = useTranslation("newlyweds");
  return (
    <div className="newlyweds-hero">
      <LazyLoadImage src={NewlywedsImg} alt="Slika šume" />
      <div className="nwh-overlay"></div>
      <div className="nwh-wrap">
        <div className="nwh-content">
          <h1 className="nwh-title">
            <span className="nwh-span1">{t("nwTitle1")}</span>
            <span className="nwh-span2">{t("nwTitle2")}</span>
          </h1>
          <p className="nwh-desc">{t("nwDesc")}</p>
          <div className="nwh-btn">
            <h3>{t("nwBtn")}</h3>
          </div>
        </div>
      </div>
    </div>
  );
}
